<div class="card flex justify-content-center p-fluid">
    <div class="flex flex-column p-fluid">
        <div
            class="border-round flex-auto flex justify-content-center align-items-center font-medium p-4 bg-light-gray">
            <div class="drag-drop-area p-fluid" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
                <p-fileUpload name="demo[]" class="p-fluid" [customUpload]="true" (uploadHandler)="onUpload($event)"
                    (onRemove)="onRemove($event)" [multiple]="true" accept="image/*,application/pdf"
                    [maxFileSize]="10000000" [style]="{ width: '40rem' }">
                    <ng-template pTemplate="content" style="overflow-y: auto">
                        <div class="flex flex-column align-items-center justify-content-center text-center"
                            *ngIf="!uploadedFiles.length">
                            <i class="pi pi-upload text-2xl mb-3"></i>
                            <p>Drag and drop files here to upload or click to browse</p>
                        </div>
                        <ul *ngIf="uploadedFiles.length" class="list-none p-0 m-0">
                            <li *ngFor="let file of uploadedFiles" class="border-bottom py-2">
                                {{ file.name }} - {{ (file.size / (1024 * 1024)) | number: '1.2-2' }} MB
                            </li>
                        </ul>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
    </div>
</div>

<div class="card p-fluid">
    <p-table [value]="invoices.value">
        <ng-template pTemplate="header">
            <tr>
                <th class="p-2"><strong>Invoice</strong></th>
                <th class="p-2"><strong>Purchase Order</strong></th>
                <th class="p-2"><strong>Invoice Date</strong></th>
                <th class="p-2"><strong>Total Amount</strong></th>
                <th class="p-2"><strong>Invoice Language</strong></th>
                <th class="p-2"><strong>Line Item</strong></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-invoice>
            <tr>
                <td>
                    <strong>{{ invoice.invoice_number }}</strong>
                </td>
                <td>
                    <strong>{{ invoice.order_number }}</strong>
                </td>
                <td>
                    <strong>{{ invoice.invoice_date }}</strong>
                </td>
                <td>
                    <strong>{{ invoice.total_amount }}</strong>
                </td>
                <td>
                    <strong>{{ invoice.invoice_language }}</strong>
                </td>
                <td>
                    <button pButton type="button" icon="fas fa-eye" (click)="viewInvoiceLineItems(invoice)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div class="flex justify-content-center">
  <p-button label="Submit" icon="pi pi-check"  (onClick)="onSubmit()" />
</div>

<p-sidebar [(visible)]="isViewInvoiceLineItems" position="right" [style]="{ width: '60%' }">
    <h3><strong>Invoice Line Items</strong></h3>
    <hr />
    <div class="grid">
        <div class="col">
            <h5>
                <strong class="inv-no-black">Invoice Number :
                    <span class="inv-no-grey">{{ selectedInvoiceNumber }}</span></strong>
            </h5>
        </div>
        <div class="col">
            <h5>
                <strong class="inv-no-black">Purchase Order :
                    <span class="inv-no-grey">{{ selectedInvoicePO }}</span></strong>
            </h5>
        </div>
        <div class="col"></div>
    </div>

    <div class="card p-3">
        <p-table [value]="lineData">
            <ng-template pTemplate="header">
                <tr>
                    <th class="p-2"><strong>Part Number</strong></th>
                    <th class="p-2"><strong>Quantity</strong></th>
                    <th class="p-2"><strong>List Price</strong></th>
                    <th class="p-2"><strong>Net Price</strong></th>
                    <th class="p-2"><strong>Amount</strong></th>
                    <th class="p-2"><strong>Description</strong></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-invoice>
                <tr>
                    <td class="p-2">
                        <strong>{{ invoice.part_number }}</strong>
                    </td>
                    <td class="p-2">
                        <strong>{{ invoice.quantity }}</strong>
                    </td>
                    <td class="p-2">
                        <strong>{{ invoice.list_price }}</strong>
                    </td>
                    <td class="p-2">
                        <strong>{{ invoice.net_price }}</strong>
                    </td>
                    <td class="p-2">
                        <strong>{{ invoice.amount }}</strong>
                    </td>
                    <td class="p-2">
                        <strong>{{ invoice.description }}</strong>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-sidebar>

<div *ngIf="loading" class="loading-overlay">
    <app-loading-screen></app-loading-screen>
</div>

<p-toast></p-toast>
